module.exports = __webpack_public_path__ + "img/products4.a0677d42.jpg";